import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  // Button,
  Card,
  CardBody,
  Label,
  Badge,
  Button,
  Input,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import "react-big-calendar/lib/css/react-big-calendar.css"

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { CSVExport } from "react-bootstrap-table2-toolkit"

// import Multiselect from "multiselect-react-dropdown"

//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as calendarAction from "../../store/ZXZlbnRDYWxlbmRhcg/actions"
// import { Calendar, momentLocalizer } from "react-big-calendar"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
// import
import timeGridPlugin from "@fullcalendar/timegrid"
import styled from "styled-components"
import interaction from "@fullcalendar/interaction"
import bootstrapPlugin from "@fullcalendar/bootstrap"
import calenderList from "@fullcalendar/list"
// import * as auditAction from "../../store/c2FsZXNG/actions" //for using employee options

const EventCalendar = (props) => {
  const { dispatch, searchBarStyle } = props
  const title = "Event Calendar"

  //Search bar and validations
  const { SearchBar } = Search
  const specificDispatch = useDispatch()

  const month = moment().format("MM")
  const year = moment().format("YYYY")
  console.log(month, year, "month and year")

  useEffect(() => {
    dispatch(calendarAction.loadRecordsMetaData())
    setTimeout(() => {
      dispatch(
        calendarAction.loadEventCalendarReportList({
          month: month,
          year: year,
        })
      )
    }, 1000)
    // dispatch(calendarAction.loadEventDetailsCalendar())
    // setCalendarData(true)
  }, [])

  const calendarUpdate = useSelector((state) => state.eventCalendar)
  console.log(calendarUpdate, "calendarUpdate")

  const {
    calendarMetaData = {},
    event_calendar_report = [],
    calendar_report = [],
  } = calendarUpdate
  console.log(calendarMetaData, "calendarMetaData")
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //Calendar filter section
  const [event, setEvent] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)
  //calendar initial state
  const [calendarData, setCalendarData] = useState({
    company: [],
    branch: [],
    event: [],
    fromDate: "",
    toDate: "",
  })
  console.log(calendarData, "CalendarData")
  //Handle change

  const handleChange = (e) => {
    setCalendarData({ ...calendarData, [e.target.name]: e.target.value })
  }

  //Calendar table
  const calendarReportTable = !isEmpty(calendar_report)
    ? calendar_report.map((calendarData, index) => {
        return {
          key: index + 1,
          _id: calendarData._id,
          title: `Booked: ${calendarData.bookedLead} Opened: ${calendarData.openLead} 
           Rejected: ${calendarData.rejectedLead} `,
          leadDetails:
            calendarData && calendarData.leadDetails
              ? calendarData.leadDetails
              : [],
          content: calendarData.openLead,
          date: calendarData.date,
          color: calendarData.isMugurtham === true ? "#000000" : "#000000",
          backgroundColor:
            calendarData.isMugurtham === true ? "#5ad577" : "#ffffff",
          description: calendarData.date,
        }
      })
    : []
  const [eventDetailsList, setEventDetailsList] = useState("")
  const [eventList, setEventList] = useState("")
  const [eventDetailsArray, setEventDetailsArray] = useState("")
  const [eventModal, setEventModal] = useState(false)
  const handleEventClose = () => setEventModal(false)

  console.log(eventDetailsArray, "eventDetailsArray")
  console.log(eventList, "eventList")
  const eventSelectDate =
    !isEmpty(eventDetailsArray) &&
    !isEmpty(eventDetailsArray._instance) &&
    eventDetailsArray._instance.range
      ? moment(eventDetailsArray._instance.range.start).format("YYYY-MM-DD")
      : ""
  console.log(eventSelectDate, "eventSelectDate")
  console.log(eventDetailsList, "eventDetailsList")

  const eventDetailsListArray = !isEmpty(eventDetailsList)
    ? eventDetailsList._def.extendedProps.leadDetails
    : []
  console.log(eventDetailsListArray, "eventDetailsListArray")

  // const companyId = !isEmpty(company) && company.map((company) => company.value)
  // const branchId = !isEmpty(branch) && branch.map((branch) => branch.value)
  // const branchIdOptions =
  //   !isEmpty(calendarMetaData) &&
  //   calendarMetaData.branchOptions.filter(
  //     (branch) =>
  //       branch.companyId === company.map((company) => company.value).toString()
  //   )
  //Apply filter submit

  const applyFilter = () => {
    var searchEvent = event && event ? event.value : ""
    var searchFromDate =
      calendarData && calendarData.fromDate
        ? moment(calendarData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      calendarData && calendarData.toDate
        ? moment(calendarData.toDate).format("YYYY-MM-DD")
        : ""

    var searchValue = {}

    if (searchEvent) {
      searchValue.eventId = searchEvent
    }

    if (searchFromDate) {
      searchValue.fromDate = searchFromDate
    }

    if (searchToDate) {
      searchValue.toDate = searchToDate
    }

    specificDispatch(calendarAction.loadEventDetailsCalendar(searchValue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

    const today = moment().format("YYYY-MM-DD")
  var date = new Date()
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
  const startingDay = moment(firstDay).format("YYYY-MM-DD")
  console.log(startingDay, "startingDay")
  const resetForm = () => {
    // setCompany([])
    // setBranch([])
    setEvent([])
    setCalendarData({
      fromDate: startingDay,
      toDate: today,
    })
  }
  let slNo = 0
  const offerReportTable = !isEmpty(eventDetailsListArray)
    ? eventDetailsListArray.map((calendarData, index) => {
        // if (eventSelectDate === calendarData.eventDate) {
        const eventName =
          calendarData && !isEmpty(calendarData.events)
            ? calendarData.events.map((data) => data.eventName)
            : ""

        // const dateFormate =
        //   !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

        const eventDate =
          calendarData && !isEmpty(calendarData.events)
            ? calendarData.events.map((data) =>
                !isEmpty(data.eventDate)
                  ? moment(data.eventDate).format(dateFormate)
                  : []
              )
            : ""
        const eventMuhurtham =
          calendarData && !isEmpty(calendarData.events)
            ? calendarData.events.map((data) =>
                data && data.isMugurtham === true ? "YES" : "NO"
              )
            : ""
        const eventNameDetails = eventName && eventName.join(",")
        const eventDateDetails = eventDate && eventDate.join(",")
        const eventMuhurthamDetails = eventMuhurtham && eventMuhurtham[0]
        // const colorCode =
        // !isEmpty(calendarMetaData) &&
        // calendarMetaData.processStatusOptions &&
        // calendarMetaData.processStatusOptions.length > 0 &&
        // calendarMetaData.processStatusOptions.find(
        //   (_) => _.processStatusId === calendarData.processStatus
        // ) &&
        // calendarMetaData.processStatusOptions.find(
        //   (_) => _.processStatusId === calendarData.processStatus
        // ).colorCode
        console.log(eventName, "eventName")
        console.log(eventNameDetails, "eventNameDetails")
        console.log(eventDateDetails, "eventDateDetails")
        console.log(eventMuhurthamDetails, "eventMuhurthamDetails")
        slNo = slNo + 1
        return {
          _id: calendarData._id,
          sNo: slNo,
          leadNo: calendarData.leadNo,
          branchId: calendarData.branchId,
          branchName: calendarData.branchName,
          companyId: calendarData.companyId,
          quoteNo: !isEmpty(calendarData.quotation.quotationNumber)
            ? calendarData.quotation.quotationNumber
            : "--",
          quoteValue: calendarData.quotation.totalPayable,
          isMuhurtham: eventMuhurthamDetails,
          status: calendarData.status,
          leadStatus: calendarData.processStatusName,
          processStatus: calendarData.processStatus,
          companyName: calendarData.companyName,
          serviceName: calendarData.leadServiceName,
          leadSourceName: calendarData.leadSourceName,
          leadType: calendarData.leadType,
          eventDate: !isEmpty(eventDateDetails) ? eventDateDetails : "--",
          eventName: eventNameDetails,
          salesAgent: !isEmpty(calendarData.leadAssign)
            ? calendarData.leadAssign
            : "--",
          leadDate: calendarData.leadDate
            ? moment(calendarData.leadDate).format("DD-MM-YYYY hh:mm A")
            : [],
          eventCount: (
            <Badge color="success" style={{ padding: "6px" }}>
              Event Count
            </Badge>
          ),
          key: index,
        }
        // } else {
        //   return {
        //     _id: "",
        //   }
        // }
      })
    : []

  console.log(event_calendar_report, "event_calendar_report")

 
  //download feature in data table
  const { ExportCSVButton } = CSVExport

  //columns for data table
  const columns = [
    // {
    //   dataField: "_id",
    //   text: "id",
    //   hidden: dropdownSelect ? false : true,
    //   headerStyle: {
    //     minWidth: "160px",
    //   },
    // },
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "quoteNo",
      text: "Quote No",
      sort: true,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    // {
    //   dataField: "quoteValue",
    //   text: "Quote Value",
    //   sort: true,
    //   headerStyle: {
    //     minWidth: "145px",
    //   },
    // },

    {
      dataField: "salesAgent",
      text: "Sales Agent",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "companyName",
      text: "Company Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "isMuhurtham",
      text: "Is Muhurtham",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadStatus",
      text: "Lead Status",
      sort: true,
      formatter: (cellContent, row) => {
        const colorCode =
          !isEmpty(calendarMetaData) &&
          calendarMetaData.processStatusOptions &&
          calendarMetaData.processStatusOptions.length > 0 &&
          calendarMetaData.processStatusOptions.find(
            (_) => _.processStatusId === row.processStatus
          ) &&
          calendarMetaData.processStatusOptions.find(
            (_) => _.processStatusId === row.processStatus
          ).colorCode
        return (
          <button
            style={{
              background: colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "5px 6px",
              borderRadius: "4px",
            }}
          >
            {row.leadStatus}
          </button>
        )
      },
      headerStyle: {
        minWidth: "148px",
      },
    },
  ]


  let serialNo = 0
  const eventTable = !isEmpty(event_calendar_report)
    ? event_calendar_report.map((data, index) => {
        // if (eventSelectDate === data.eventDate) {

        serialNo = serialNo + 1

        // const dateFormate =
        //   !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
        var leadDate = !isEmpty(data.leadDate)
          ? moment(data.leadDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : []
        var eventDate = !isEmpty(data.eventDate)
          ? moment(data.eventDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(dateFormate)
          : []

        const colorCode =
          !isEmpty(calendarMetaData) &&
          calendarMetaData.processStatusOptions &&
          calendarMetaData.processStatusOptions.length > 0 &&
          calendarMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.processStatus
          ) &&
          calendarMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.processStatus
          ).colorCode

        console.log(colorCode, "colorCode")
        return {
          _id: data._id,
          serialNo: serialNo,
          leadDataNo: data.leadNo,
          branchId: data.branchId,
          branchNameData: data.branchName,
          companyId: data.companyId,
          quotationNo: !isEmpty(data.quotationNumber)
            ? data.quotationNumber
            : "--",
          budgetData: data.budget,
          isMuhurthamData: !isEmpty(data.isMugurtham) && data.isMugurtham === true ? "YES" : "NO",
          status: data.status,
          leadStatusData: data.processStatusName,
          processStatus: data.processStatus,
          companyNameData: data.companyName,
          serviceName: data.leadServiceName,
          leadSourceName: data.leadSourceName,
          leadEventId: data.leadEventId,
          leadType: data.leadType,
          eventDateData: eventDate,
          eventNameData: data.eventName,
          salesAgentData: !isEmpty(data.salesAgentName)
            ? data.salesAgentName
            : "--",
          leadDate: leadDate,
          eventCount: (
            <Badge color="success" style={{ padding: "6px" }}>
              Event Count
            </Badge>
          ),
          key: index,
        }
        // } else {
        //   return {
        //     _id: "",
        //   }
        // }
      })
    : []
  
    console.log(eventTable, "eventTable")
  const eventColumns = [
    {
      dataField: "serialNo",
      text: "S.No",
    },
    {
      dataField: "quotationNo",
      text: "Quote No",
      sort: true,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "leadDataNo",
      text: "Lead No",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "budgetData",
      text: "Budget",
      sort: true,
      headerStyle: {
        minWidth: "145px",
      },
    },

    {
      dataField: "salesAgentData",
      text: "Sales Agent",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "companyNameData",
      text: "Company Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "branchNameData",
      text: "Branch Name",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "eventDateData",
      text: "Event Date",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventNameData",
      text: "Event Name",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "isMuhurthamData",
      text: "Is Muhurtham",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadStatusData",
      text: "Lead Status",
      sort: true,
      formatter: (cellContent, row) => {
        const colorCode =
          !isEmpty(calendarMetaData) &&
          calendarMetaData.processStatusOptions &&
          calendarMetaData.processStatusOptions.length > 0 &&
          calendarMetaData.processStatusOptions.find(
            (_) => _.processStatusId === row.processStatus
          ) &&
          calendarMetaData.processStatusOptions.find(
            (_) => _.processStatusId === row.processStatus
          ).colorCode
        return (
          <button
            style={{
              background: colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "5px 6px",
              borderRadius: "4px",
            }}
          >
            {row.leadStatusData}
          </button>
        )
      },
      headerStyle: {
        minWidth: "168px",
      },
    },
  ]

  // pagination options
  const eventOptions = {
    sizePerPage: 50,
    totalSize: eventTable.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  const options = {
    sizePerPage: 50,
    totalSize: eventDetailsListArray.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  //Calendar filter section
  const [companyDetails, setCompanyDetails] = useState([])
  const [branchDetails, setBranchDetails] = useState([])

  //button spinner state
  const [btnCalendarLoader, setBtnCalendarLoader] = useState(false)
  //dropdown options
  const handleCompanyChange = (e) => {
    setCompanyDetails(e)
    setBranchDetails([])
  }

  const companyList =
    !isEmpty(companyDetails) && companyDetails.map((company) => company.value)
  const branchList =
    !isEmpty(branchDetails) && branchDetails.map((branch) => branch.value)
  const branchListOptions =
    !isEmpty(calendarMetaData) &&
    calendarMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companyDetails.map((company) => company.value).toString()
    )
  //Apply filter submit

  const applyCalendarFilter = () => {
    var searchCompany = companyDetails && companyDetails ? companyList : ""
    var searchBranch = branchDetails && branchDetails ? branchList : ""

    var searchValue = {}
    searchValue.month = month
    searchValue.year = year
    if (searchCompany) {
      searchValue.companyId = searchCompany
    }

    if (searchBranch) {
      searchValue.branchId = searchBranch
    }
    specificDispatch(calendarAction.loadEventCalendarReportList(searchValue))
    setBtnCalendarLoader(true)
    setTimeout(() => {
      setBtnCalendarLoader(false)
    }, 2000)
  }

  //Events for big calendar

  const StyledWrapper = styled.div`
    .fc-event {
      width: 120px !important;
      border: none;
      marginleft: 5px;
    }
    .fc-daygrid-event {
      white-space: normal !important;
      flex-wrap: wrap;
      align-items: normal !important;
    }
  `

  // const [eventsData, setEventsData] = useState()
  const [eventDetails, setEventDetails] = useState(false)
  // const [listDetails, setListDetails] = useState(false)
  // console.log(setListDetails, "set")
  const renderEventContent = (eventInfo) => {
    return (
      <>
        <b>{eventInfo.timeText}</b>
        <b>{eventInfo.event.title}</b>
      </>
    )
  }

  console.log(eventDetailsList, "eventDetailsList")

  useEffect(() => {
    if (eventDetails) {
      dispatch(
        calendarAction.loadEventDetailsCalendar({
          fromDate: startingDay,
          toDate: today,
        })
      )
      setCalendarData({
        fromDate: startingDay,
        toDate: today,
      })
    }
  }, [eventDetails])

  //Calendar component end
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        </Container>
        {eventModal && (
          <Modal size="xl" show={eventModal} onHide={handleEventClose}>
            <Modal.Header style={{ backgroundColor: "#e40d8c" }}>
              <h5
                style={{
                  color: "#ffffff",
                  fontWeight: 800,
                  textTransform: "uppercase",
                }}
              >
                Event Details
              </h5>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col md="12" lg="12" xl="12">
                  <Card>
                    <CardBody>
                      <PaginationProvider
                        pagination={paginationFactory(options)}
                        keyField="_id"
                        columns={columns}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="_id"
                            data={offerReportTable}
                            columns={columns}
                            search
                            exportCSV
                          >
                            {(props) => (
                              <div>
                                <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                  <Row className="d-flex flex-row">
                                    <Col className="mb-3" md="4">
                                      <div className="d-flex flex-row ">
                                        <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                          <div
                                            className="position-relative mt-7"
                                            style={searchBarStyle || null}
                                          >
                                            <SearchBar {...props.searchProps} />
                                            <i className="bx bx-search-alt search-icon" />
                                          </div>
                                        </div>
                                      </div>{" "}
                                    </Col>
                                    <Col>
                                      <ExportCSVButton
                                        className="border float-right mx-10"
                                        style={{
                                          float: "right",
                                          backgroundColor: "#e40d8c",
                                          color: "#ffffff",
                                        }}
                                        {...props.csvProps}
                                      >
                                        Download{" "}
                                      </ExportCSVButton>{" "}
                                    </Col>
                                    <Col>
                                      <BootstrapTable
                                        {...props.baseProps}
                                        responsive
                                        striped={true}
                                        bordered={true}
                                        keyField="_id"
                                        columns={columns}
                                        {...paginationTableProps}
                                      />
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{ marginTop: "5px" }}
                                    className="align-items-md-center mt-30"
                                  >
                                    <Col className="inner-custom-pagination d-flex">
                                      <div className="d-inline d-flex flex-row">
                                        <SizePerPageDropdownStandalone
                                          {...paginationProps}
                                        />
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            marginTop: "8px",
                                            marginLeft: "4px",
                                          }}
                                        >
                                          <PaginationTotalStandalone
                                            {...paginationProps}
                                          />
                                        </div>
                                      </div>
                                      <div
                                        className="text-md-right ms-auto"
                                        style={{ zIndex: 0 }}
                                      >
                                        <PaginationListStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </div>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  setEventDetailsList("")
                  setEventModal(false)
                }}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {eventDetails ? (
          <Row>
            <Col xs={12} style={{ paddingRight: "33px" }}>
              <Card>
                <CardBody>
                  <Row className="mb-4">
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Branch"}>
                          {"Event"}
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="event"
                        value={event}
                        onChange={(e) => setEvent(e)}
                        options={
                          calendarMetaData ? calendarMetaData.eventOptions : []
                        }
                        placeholder="Select Event"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Branch"}>
                          {"From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="fromDate"
                        value={calendarData.fromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Select From Date"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Branch"}>
                          {"To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="toDate"
                        value={calendarData.toDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Select To Date"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          onClick={() => resetForm()}
                          className="btn btn-danger btn-label simple-form-Reset-btn"
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={() => {
                            applyFilter()
                          }}
                          className="btn btn-success mx-2"
                        >
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            <>
                              <i className="bx bx-filter-alt label-icon"></i>{" "}
                              {" Apply Filter"}
                            </>
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Row>
              <Col md="12" lg="12" xl="12">
                <Card>
                  <CardBody>
                    <Row>
                      <Col>
                        <div
                          className="mb-4"
                          onClick={() => setEventDetails(false)}
                        >
                          <i className="fa fa-times font-size-14 event-close-icon"></i>
                        </div>
                      </Col>
                    </Row>
                    <PaginationProvider
                      pagination={paginationFactory(eventOptions)}
                      keyField="_id"
                      columns={eventColumns}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="_id"
                          data={eventTable}
                          columns={eventColumns}
                          search
                          exportCSV
                        >
                          {(props) => (
                            <div>
                              <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                <Row className="d-flex flex-row">
                                  <Col className="mb-3" md="4">
                                    <div className="d-flex flex-row ">
                                      <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <div
                                          className="position-relative mt-7"
                                          style={searchBarStyle || null}
                                        >
                                          <SearchBar {...props.searchProps} />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </div>{" "}
                                  </Col>
                                  <Col>
                                    <ExportCSVButton
                                      className="border float-right mx-10"
                                      style={{
                                        float: "right",
                                        backgroundColor: "#e40d8c",
                                        color: "#ffffff",
                                      }}
                                      {...props.csvProps}
                                    >
                                      Download{" "}
                                    </ExportCSVButton>{" "}
                                  </Col>
                                  <Col>
                                    <BootstrapTable
                                      {...props.baseProps}
                                      responsive
                                      striped={true}
                                      bordered={true}
                                      keyField="_id"
                                      columns={eventColumns}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  style={{ marginTop: "5px" }}
                                  className="align-items-md-center mt-30"
                                >
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline d-flex flex-row">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "8px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        <PaginationTotalStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="text-md-right ms-auto"
                                      style={{ zIndex: 0 }}
                                    >
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Row>
        ) : (
          <>
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <Row className="mb-4">
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {" "}
                            {"Company"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="companyDetails"
                          value={companyDetails}
                          isMulti
                          onChange={(e) => handleCompanyChange(e)}
                          options={
                            calendarMetaData
                              ? calendarMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branchDetails"
                          isMulti
                          value={branchDetails}
                          onChange={(e) => setBranchDetails(e)}
                          options={branchListOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        style={{ marginTop: "40px" }}
                      >
                        <Button
                          type="submit"
                          onClick={() => {
                            applyCalendarFilter()
                          }}
                          className="btn btn-success"
                        >
                          {" "}
                          {btnCalendarLoader && btnCalendarLoader ? (
                            <ButtonSpinner />
                          ) : (
                            <i className="bx bx-search-alt search-icon mt-1" />
                          )}{" "}
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row
              style={{ padding: "10px", borderRadius: "2px", height: "100%" }}
            >
              <div
                className="mb-4"
                style={{
                  height: "100%",
                  padding: "15px",
                  backgroundColor: "white",
                }}
              >
                <StyledWrapper>
                  <FullCalendar
                    plugins={[
                      dayGridPlugin,
                      interaction,
                      timeGridPlugin,
                      calenderList,
                      bootstrapPlugin,
                    ]}
                    initialView="dayGridMonth"
                    events={calendarReportTable}
                    headerToolbar={{
                      left: "prev,next,today",
                      center: "title",
                      right: "dayGridMonth,listMonth,new",
                    }}
                    selectable={true}
                    customButtons={{
                      new: {
                        text: "EventDetails",
                        click: () => {
                          setEventList(calendar_report)
                          setEventDetails(true)
                        },
                      },
                    }}
                    datesSet={(dateInfo) => {
                      console.log(dateInfo, "dateInfo")
                    }}
                    dateClick={() => {
                      setEventModal(true)
                    }}
                    eventClick={(info) => {
                      setEventModal(true)
                      setEventDetailsList(info.event)
                      setEventDetailsArray(info.event)
                    }}
                    editable={true}
                    eventTextColor={"#383838"}
                    dayHeaderClassNames={".fc .fc-toolbar-title"}
                    viewClassNames={".fc-theme-bootstrap"}
                    themeSystem="bootstrap"
                    buttonText={{
                      month: "Month",
                      list: "List",
                      today: "Today",
                    }}
                    selectMirror={true}
                    eventContent={renderEventContent}
                  />
                </StyledWrapper>
                {/* <button
                    type="button"
                    className="event-1-button"
                    onClick={() => setEventDetails(!eventDetails)}
                  >
                    Event Details
                  </button> */}
              </div>
            </Row>
          </>
        )}
      </div>
    </React.Fragment>
  )
}

EventCalendar.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  onNavigate: PropTypes.func,
  onView: PropTypes.any,
  date: PropTypes.any,
  time: PropTypes.any,
  event: PropTypes.any,
  eventInfo: PropTypes.any,
  baseProps: PropTypes.any,
  label: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EventCalendar)
)
